import React, { useState }from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetPagination } from 'reducers/paginationRegistersSlice';
import { resetFilters } from 'reducers/filtersRegistersSlice'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import CodeLerSettings from "pages/settings/CodeLerSettings";
import DescriptionSettings from "pages/settings/DescriptionSettings" 
import TreatmentTypeSettings from "pages/settings/TreatmentTypeSettings"
import ProcessTypeSettings from "pages/settings/ProcessTypeSettings"
import DangerousnessSettings from "pages/settings/DangerousnessSettings"  
import FormRegisterBook from "pages/registerBook/RegisterBookFilter";
 
const HomeRegisterBook = () => {
    const {t,i18n} = useTranslation(['listDataRegisterBook']);
    const dispatch = useDispatch();
    const filtersRegistersDetails = useSelector((state) => state.filtersRegisters); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalCodeLerSettings, setShowModalCodeLerSettings] = useState(false);
    const [showModalDescriptionSettings, setShowModalDescriptionSettings] = useState(false);
    const [showModalDangerousnessSettings, setShowModalDangerousnessSettings] = useState(false);
    const [showModalProcessTypeSettings, setShowModalProcessTypeSettings] = useState(false);
    const [showModalTreatmentTypeSettings, setShowModalTreatmentTypeSettings] = useState(false); 
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false); 
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(false); 
    const [showModalFormSettings, setShowModalFormSettings] = useState(false); 
    const [showModalTicketsSettings, setShowModalTicketsSettings] = useState(false); 
    const [showModalContractSettings, setShowModalContractSettings] = useState(false);  
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(false); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(false); 
    const [showModalShippingsSettings, setShowModalShippingsSettings] = useState(false); 
    const [showModalRegisterBookSettings, setShowModalRegisterBookSettings] = useState(true); 
    const [valueTabs, setValueTabs] = useState("sheetin");
 
    const scriptUrl = '/js/sb-admin-2.min.js'; 

    function changeSelectedLanguage(){
        i18n.language==="es"?i18n.changeLanguage("en"):i18n.changeLanguage("es");
    };

    const closeModalRegisterBook = () => {    
        setIndexShowSettings(0);
        setIndexShowSettings(indexShowSettings);
        setShowModalCodeLerSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalStoreSettings(showModalStoreSettings); 
        setShowModalFormSettings(showModalFormSettings);
        setShowModalTicketsSettings(showModalTicketsSettings);
        setShowModalGeneralSettings(showModalGeneralSettings);
        setShowModalContractSettings(showModalContractSettings);
        setShowModalArticlesSettings(showModalArticlesSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        setShowModalShippingsSettings(showModalShippingsSettings);
        setValueTabs("sheetin");
        dispatch(resetPagination());
        dispatch(resetFilters());
        setShowModalRegisterBookSettings(showModalRegisterBookSettings);
        return () => {};
    };
    
    function openModaCodeLerSettings(){
        setIndexShowSettings(8);
        setIndexShowSettings(indexShowSettings);
        setShowModalCodeLerSettings(true);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalEmployeeSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaDescriptionSettings(){
        setIndexShowSettings(9);
        setIndexShowSettings(indexShowSettings);
        setShowModalCodeLerSettings(false);
        setShowModalDescriptionSettings(true);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalEmployeeSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaTreatmentTypeSettings(){
        setIndexShowSettings(10);
        setIndexShowSettings(indexShowSettings);
        setShowModalCodeLerSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(true); 
        setShowModalEmployeeSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaProcessTypeSettings(){
        setIndexShowSettings(11);
        setIndexShowSettings(indexShowSettings);
        setShowModalCodeLerSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(true);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalEmployeeSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaDangerousnessSettings(){
        setIndexShowSettings(12);
        setIndexShowSettings(indexShowSettings);
        setShowModalCodeLerSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(true);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalEmployeeSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/registerbook">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersRegistersDetails.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersRegistersDetails.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.idFrom}
                    </li>
                    <div className={filtersRegistersDetails.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersRegistersDetails.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.idTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.idTo}
                    </li>
                    
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Contacts_Store_Master"))&&
                        <>
                            <div className={filtersRegistersDetails.defaultStoreIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Store_From')}
                            </div>
                            <li className={filtersRegistersDetails.defaultStoreIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.defaultStoreIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.defaultStoreIdFrom}
                            </li>
                            <div className={filtersRegistersDetails.defaultStoreIdTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Store_To')}
                            </div>
                            <li className={filtersRegistersDetails.defaultStoreIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.defaultStoreIdTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.defaultStoreIdTo}
                            </li>
                        </>
                    }
                    {(roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Contacts_Store_Master"))
                        || roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Contacts_User_Master"))) &&
                        <>
                            <div className={filtersRegistersDetails.useraccountIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                                {t('Text_Filter_UserAccount_From')}
                            </div>
                            <li className={filtersRegistersDetails.useraccountIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.useraccountIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.useraccountIdFrom}
                            </li>
                            <div className={filtersRegistersDetails.useraccountIdTo===''?"sidebar-heading":"sidebar-heading text-white"}> 
                                {t('Text_Filter_UserAccount_To')}
                            </div>
                            <li className={filtersRegistersDetails.useraccountIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.useraccountIdTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.useraccountIdTo}
                            </li>
                        </>
                    }

                    <div className={filtersRegistersDetails.registerbookFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_formdiFrom_From')}
                    </div>
                    <li className={filtersRegistersDetails.registerbookFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.registerbookFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.registerbookFrom}
                    </li>
                    <div className={filtersRegistersDetails.registerbookTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_formdiFrom_To')}
                    </div>
                    <li className={filtersRegistersDetails.registerbookTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.registerbookTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.registerbookTo}
                    </li>

                    <div className={filtersRegistersDetails.preiddocSheetFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_PreiddocSheet_From')}
                    </div>
                    <li className={filtersRegistersDetails.preiddocSheetFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.preiddocSheetFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.preiddocSheetFrom}
                    </li>
                    <div className={filtersRegistersDetails.preiddocSheetTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_PreiddocSheet_To')}
                    </div>
                    <li className={filtersRegistersDetails.preiddocSheetTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.preiddocSheetTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.preiddocSheetTo}
                    </li>
                    <div className={filtersRegistersDetails.sufiddocSheetFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_SufiddocSheet_From')}
                    </div>
                    <li className={filtersRegistersDetails.sufiddocSheetFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.sufiddocSheetFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.sufiddocSheetFrom}
                    </li>
                    <div className={filtersRegistersDetails.sufiddocSheetTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_SufiddocSheet_To')}
                    </div>
                    <li className={filtersRegistersDetails.sufiddocSheetTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.sufiddocSheetTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.sufiddocSheetTo}
                    </li>
                   
                    <div className={filtersRegistersDetails.numberDTFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_NumberNT_From')}
                    </div>
                    <li className={filtersRegistersDetails.numberDTFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.numberDTFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.numberDTFrom}
                    </li>
                    <div className={filtersRegistersDetails.numberDTTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_NumberNT_To')}
                    </div>
                    <li className={filtersRegistersDetails.numberDTTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.numberDTTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.numberDTTo}
                    </li> 

                    <div className={filtersRegistersDetails.dateSheetFrom===null || filtersRegistersDetails.dateSheetFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_DateSheet_From')}
                    </div>
                    <li className={filtersRegistersDetails.dateSheetFrom===null || filtersRegistersDetails.dateSheetFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        {filtersRegistersDetails.dateSheetFrom===null || filtersRegistersDetails.dateSheetFrom===''? t('Text_Filter_Not_Apply'): new Date(filtersRegistersDetails.dateSheetFrom).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
                    <div className={filtersRegistersDetails.dateSheetTo===null || filtersRegistersDetails.dateSheetTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_DateSheet_To')}
                    </div>
                    <li className={filtersRegistersDetails.dateSheetTo===null || filtersRegistersDetails.dateSheetTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.dateSheetTo===null || filtersRegistersDetails.dateSheetTo===''? t('Text_Filter_Not_Apply'):new Date(filtersRegistersDetails.dateSheetTo).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
                    {valueTabs==='sheetin'?
                        <>
                            <div className={filtersRegistersDetails.ori_tras_tradenameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_tradename_Ori_TrasFrom')}
                            </div>
                            <li className={filtersRegistersDetails.ori_tras_tradenameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.ori_tras_tradenameFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.ori_tras_tradenameFrom}
                            </li>
                            <div className={filtersRegistersDetails.ori_tras_tradenameTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_tradename_Ori_TrasTo')}
                            </div>
                            <li className={filtersRegistersDetails.ori_tras_tradenameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.ori_tras_tradenameTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.ori_tras_tradenameTo}
                            </li> 
                            <div className={filtersRegistersDetails.opt_tras_tradenameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_tradename_Opt_TrasFrom')}
                            </div>
                            <li className={filtersRegistersDetails.opt_tras_tradenameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.opt_tras_tradenameFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.opt_tras_tradenameFrom}
                            </li>
                            <div className={filtersRegistersDetails.opt_tras_tradenameTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_tradename_Opt_TrasTo')}
                            </div>
                            <li className={filtersRegistersDetails.opt_tras_tradenameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.opt_tras_tradenameTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.opt_tras_tradenameTo}
                            </li> 
                            <div className={filtersRegistersDetails.rel_trans_tradenameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_tradename_Rel_TransFrom')}
                            </div>
                            <li className={filtersRegistersDetails.rel_trans_tradenameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.rel_trans_tradenameFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.rel_trans_tradenameFrom}
                            </li>
                            <div className={filtersRegistersDetails.rel_trans_tradenameTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_tradename_Rel_TransTo')}
                            </div>
                            <li className={filtersRegistersDetails.rel_trans_tradenameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.rel_trans_tradenameTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.rel_trans_tradenameTo}
                            </li> 
                     </>:
                     <> 
                        <div className={filtersRegistersDetails.dest_tras_tradenameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                            {t('Text_Filter_tradename_Dest_TrasFrom')}
                        </div>
                        <li className={filtersRegistersDetails.dest_tras_tradenameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                            { filtersRegistersDetails.dest_tras_tradenameFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.dest_tras_tradenameFrom}
                        </li>
                        <div className={filtersRegistersDetails.dest_tras_tradenameTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                            {t('Text_Filter_tradename_Dest_TrasTo')}
                        </div>
                        <li className={filtersRegistersDetails.dest_tras_tradenameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                            { filtersRegistersDetails.dest_tras_tradenameTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.dest_tras_tradenameTo}
                        </li> 
                        <div className={filtersRegistersDetails.rel_trans_tradenameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                            {t('Text_Filter_tradename_Rel_TransFrom')}
                        </div>
                        <li className={filtersRegistersDetails.rel_trans_tradenameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                            { filtersRegistersDetails.rel_trans_tradenameFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.rel_trans_tradenameFrom}
                        </li>
                        <div className={filtersRegistersDetails.rel_trans_tradenameTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                            {t('Text_Filter_tradename_Rel_TransTo')}
                        </div>
                        <li className={filtersRegistersDetails.rel_trans_tradenameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                            { filtersRegistersDetails.rel_trans_tradenameTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.rel_trans_tradenameTo}
                        </li> 
                     </>
                    } 
                    <div className={filtersRegistersDetails.codelerFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_CodeLer_From')}
                    </div>
                    <li className={filtersRegistersDetails.codelerFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.codelerFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.codelerFrom}
                    </li>
                    <div className={filtersRegistersDetails.codelerTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_CodeLer_To')}
                    </div>
                    <li className={filtersRegistersDetails.codelerTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersRegistersDetails.codelerTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.codelerTo}
                    </li> 
                    {valueTabs!=='sheetin'&&
                        <>
                            <div className={filtersRegistersDetails.codetreatmentFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_Treatment_From')}
                            </div>
                            <li className={filtersRegistersDetails.codetreatmentFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.codetreatmentFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.codetreatmentFrom}
                            </li>
                            <div className={filtersRegistersDetails.codetreatmentTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_Treatment_To')}
                            </div>
                            <li className={filtersRegistersDetails.codetreatmentTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.codetreatmentTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.codetreatmentTo}
                            </li> 

                            <div className={filtersRegistersDetails.codedangerousnessFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_Dangerousness_From')}
                            </div>
                            <li className={filtersRegistersDetails.codedangerousnessFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.codedangerousnessFrom==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.codedangerousnessFrom}
                            </li>
                            <div className={filtersRegistersDetails.codedangerousnessTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_Dangerousness_To')}
                            </div>
                            <li className={filtersRegistersDetails.codedangerousnessTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersRegistersDetails.codedangerousnessTo==='' ? t('Text_Filter_Not_Apply'): filtersRegistersDetails.codedangerousnessTo}
                            </li> 
                        </>
                    } 
  
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/registerbook" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                  
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_CodeLers"))&&
                                    <Link className="collapse-item"  to="/registerbook" onClick={openModaCodeLerSettings}>{t('SubMenu_Settings_Type_CodeLers')} </Link>}
                                  
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Desciption"))&&
                                    <Link className="collapse-item"  to="/registerbook" onClick={openModaDescriptionSettings}>{t('SubMenu_Settings_Type_Description')} </Link>}

                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TreatmentType"))&&
                                    <Link className="collapse-item"  to="/registerbook" onClick={openModaTreatmentTypeSettings}>{t('SubMenu_Settings_Type_TreatmentType')} </Link>}

                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_ProcessType"))&&
                                    <Link className="collapse-item"  to="/registerbook" onClick={openModaProcessTypeSettings}>{t('SubMenu_Settings_Type_ProcessType')} </Link>}

                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Dangerousness"))&&
                                    <Link className="collapse-item"  to="/registerbook" onClick={openModaDangerousnessSettings}>{t('SubMenu_Settings_Type_Dangerousnes')} </Link>}
              
                                    <Link className="collapse-item" to="/registerbook" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalRegisterBook} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                             <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <FormRegisterBook  
                    showModalRegisterBookSettings={showModalRegisterBookSettings}
                    valueTabs={valueTabs}
                    setValueTabs={setValueTabs}
                />
                <CodeLerSettings  
                    showModalCodeLerSettings={showModalCodeLerSettings}
                    setShowModalCodeLerSettings={setShowModalCodeLerSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={true}
                />
                <DescriptionSettings  
                    showModalDescriptionSettings={showModalDescriptionSettings}
                    setShowModalDescriptionSettings={setShowModalDescriptionSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={true}
                />
                 <TreatmentTypeSettings  
                    showModalTreatmentTypeSettings={showModalTreatmentTypeSettings}
                    setShowModalTreatmentTypeSettings={setShowModalTreatmentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={true}
                />
                <ProcessTypeSettings  
                    showModalProcessTypeSettings={showModalProcessTypeSettings}
                    setShowModalProcessTypeSettings={setShowModalProcessTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={true}
                />
                 <DangerousnessSettings  
                    showModalDangerousnessSettings={showModalDangerousnessSettings}
                    setShowModalDangerousnessSettings={setShowModalDangerousnessSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={true}
                /> 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeRegisterBook;
